import type { StudentProgramSummary } from "./types";

interface UniversityEnrollmentCountInput {
  activeStudentCount?: number | null;
  studentProgramSummary?: StudentProgramSummary[] | null;
}

export function getUniversityEnrollmentCount({
  activeStudentCount,
  studentProgramSummary
}: UniversityEnrollmentCountInput) {
  const completedStudentCount = studentProgramSummary?.reduce((sum, summary) => sum + summary.completions, 0) ?? 0;

  return (activeStudentCount ?? 0) + completedStudentCount;
}
